import React from 'react'

const List = (props) => {
    return (
        <div className="list">
            <div className="name">
                <h3>Top 1</h3>
                <img src="https://i1.wp.com/bootcampmilitaryfitnessinstitute.com/wp-content/uploads/2015/11/royal-gurkha-rifles-camp-flag.png?resize=289%2C174&ssl=1" alt="" srcset="" />
                <h4>{props.name}</h4>
                <h5>{props.location}</h5>
            </div>
            <div className="marks">
                <h2>{props.marks}</h2>
            </div>
        </div>
    )
}

export default List
